import { createActionGroup, emptyProps, props } from '@ngrx/store';
import type { MeasurementUnit } from '../../models/measurement-unit.model';

export const MeasurementUnitsActions = createActionGroup({
  source: 'MeasurementUnits',
  events: {
    measurement_units_needed: emptyProps(),
    measurement_units_load_start: emptyProps(),
    measurement_units_loaded: props<{ measurementUnits: Record<string, MeasurementUnit> }>()
  }
});
